<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                            Search Form
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="pa-2">
                                        <v-col md="3" cols="12">
                                            <v-autocomplete
                                                label="Search Product Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value"
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.name}`"
                                                item-value="product_id"
                                                autocomplete="off"
                                                clearable
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col md="2" cols="12">
                                            <v-date-input
                                                label="From Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>
                                        <v-col md="2" cols="12">
                                            <v-date-input
                                                label="To Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>
                                        <v-col lg="2" md="2" cols="12">
                                            <v-btn
                                                class="bg-brand w-15"
                                                type="submit"
                                                ref="searchButton"
                                            >Search</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>           
        </v-container>

        <v-container fluid style="margin-top: -20px;">
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                            Requisition Report
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                    <v-col md="4" cols="6">
                                        <v-text-field
                                        v-model="search"
                                        append-inner-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details
                                        density="compact"
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        class="pl-2"
                                        clearable
                                        ></v-text-field>
                                    </v-col>
                                    <v-col md="4" cols="6">
                                        <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                            >
                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="red"
                                                @click="exportToPDF"
                                                >PDF</v-btn>
                                            </v-btn-group>
                                    </v-col>
                                </v-row>
                                
                                <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :loading="loading"
                                    v-model:items-per-page="itemsPerPage"
                                    :search="search"
                                    :hover="true"
                                    density="compact"
                                    >
                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>
                                    <template v-slot:item.req_date="{ item }">
                                        {{ formatDateDash(item.req_date) }}
                                    </template>
                                    <template v-slot:item.require_date="{ item }">
                                        {{ formatDateDash(item.require_date) }}
                                    </template>
                                    <template v-slot:item.pr_status="{ item }">
                                        <v-chip :color="statusMap[item.pr_status]?.color || 'grey'" size="small" class="text-capitalize">
                                            {{ statusMap[item.pr_status]?.label || "Unknown" }}
                                        </v-chip>
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, computed } from "vue";
import { toast } from "vue3-toastify";
import formatDateView, { formatDateDash } from "@/plugins/dateFormatView";
import formattedDate from "@/plugins/dateFormatter";
import statusMap from "@/utils/statusMap";

export default {
    data: () => ({
        itemsPerPage: -1,
        panel: [0],
        panel2: [0],
        search: "",
        statusMap,
        headers: [
            { title: "#SL", key: "index", align: "center", width: "5%", sortable: false },
            { title: "PR Code", key: "req_code", align: "left", width: "150px" },
            { title: "PR Date", key: "req_date", align: "left", width: "150px" },
            { title: "Company", key: "company", align: "left", width: "150px" },
            { title: "Branch", key: "branch", align: "left", width: "150px" },
            { title: "Department", key: "department", align: "left", width: "150px" },
            { title: "Warehouse", key: "warehouse", align: "left", width: "150px" },
            { title: "Required Date", key: "require_date", align: "left", width: "150px" },
            { title: "Product Code", key: "product_code", align: "left", width: "150px" },
            { title: "Product Name", key: "product", align: "left", width: "150px" },
            { title: "Quantity", key: "qty", align: "left", width: "150px" },
            { title: "Price", key: "rate", align: "left", width: "150px" },
            { title: "Amount", key: "amount", align: "left", width: "150px" },
            { title: "Unit", key: "unit", align: "left", width: "150px" },
            { title: "Requested By", key: "created_by", align: "left", width: "150px" },
            { title: "PR Status", key: "pr_status", align: "left", width: "150px" },
            { title: "Approved", key: "approval_status", align: "left", width: "150px" },
            { title: "Approved By", key: "approved_by", align: "left", width: "200px" },
            { title: "Remarks", key: "remarks", align: "left", width: "150px" }
        ]
    }),
    created() {
        if (this.$store.getters.getProductMapList.length == 0) {
            this.loading = true;
            this.$store.dispatch("getProductMapList").then((response) => {
                this.loading = false;
            });
        }
    },
    computed: {
        getSchema() {
            return this.$store.getters.getPurRequisitionReport;
        },
        getProductMapList() {
            let data = this.$store.getters.getProductMapList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },
        /* flattenedData() {
            return this.getSchema.map((item, index) => ({
                index: index + 1,
                code: item.code,
                supplier_name: item.supplier_name,
                s_type: item.s_type,
                s_country: item.s_country,
                supplier_email: item.supplier_email,
                supplier_mobile: item.supplier_mobile,
                status: item.status
            }));
        } */
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                // Add your validation rules here
            }),
        });

        const product_id = useField("product_id");
        const from_date = useField("from_date");
        const to_date = useField("to_date");
        const loading = ref(false);
        const store = useStore();

        const submit = handleSubmit((values) => {
            loading.value = true;
            values.from_date = formattedDate(from_date.value.value);
            values.to_date = formattedDate(to_date.value.value);
            store
                .dispatch("getPurRequisitionReport", values)
                .then((response) => {
                    loading.value = false;
                })
                .catch((error) => {
                    loading.value = false;
                    toast.error(error?.response?.data?.message || "An error occurred");
                });
        });

        return {
            product_id,
            from_date,
            to_date,
            submit,
            loading,
        };
    },
    methods: {
        formatDateDash,formattedDate,statusMap,
        exportToPDF() {
            const columns = [
                "#SL",
                "PR Code",
                "PR Date",
                "Branch",
                "Warehouse",
                "Required Date",
                "Product Name",
                "Quantity",
                "Price",
                "Amount",
                "Unit",
                "Approved",
            ];
            let serialNum = 1;
            const rows = this.getSchema.map(item => [
                serialNum++,
                item.req_code ?? "",
                formatDateDash(item.req_date),
                item.branch ?? "",
                item.warehouse ?? "",
                formatDateDash(item.require_date),
                item.product ?? "",
                item.qty,
                item.rate,
                item.amount,
                item.product ?? "",
                item.approval_status,
            ]);

            this.$exportTableToPDF(columns, rows, "Supplier List Report", "supplier_list_report_" + this.$fileDate());
        },

        exportToExcel() {
            var data = [
                [
                    "#SL",
                    "PR Code",
                    "PR Date",
                    "Company",
                    "Branch",
                    "Department",
                    "Warehouse",
                    "Required Date",
                    "Product Code",
                    "Product Name",
                    "Quantity",
                    "Price",
                    "Amount",
                    "Unit",
                    "Requested By",
                    "PR Status",
                    "Approved",
                    "Approved By",
                    "Remarks",
                ],
            ];

            let serialNum = 1;
            this.getSchema.forEach(item => {
                data.push([
                    serialNum++,
                    item.req_code ?? "",
                    formatDateDash(item.req_date),
                    item.company ?? "",
                    item.branch ?? "",
                    item.department ?? "",
                    item.warehouse ?? "",
                    formatDateDash(item.require_date),
                    item.product_code ?? "",
                    item.product ?? "",
                    item.qty ?? 0,
                    item.rate ?? 0,
                    item.amount ?? 0,
                    item.unit ?? "",
                    item.created_by ?? "",
                    statusMap[item.pr_status]?.label ?? "",
                    item.approval_status,
                    item.approved_by ?? "",
                    item.remarks ?? ""
                ]);
            });

            this.$exportTableToExcel(data, "pr_report_" + this.$fileDate());
        }

    },
};
</script>